export default __webpack_public_path__ + "static/media/ep29.5bd59f6b.jpeg";